
export const responsiveViews = [
  "times-contrarian",
  "about",
  "about-rust",
  "account",
  "album",
  "credits",
  "greenland",
  "info-card",
  "login",
  "logout",
  "map",
  "menu",
  "playlist",
  "privacy",
  "redirect",
  "rustie",
  "terms",
  "news",
  "movie-night",
  "contact",
];

export const pathInResponsiveViews = () => {
  let currentPath = window.location.pathname;
  currentPath = currentPath.split("/")[1]
  return responsiveViews.includes(currentPath);
}
